import { ObjectType, Field, InputType, Int, ID } from 'type-graphql'
import { BoardTemplate } from './board-template.js'

@InputType({ description: 'Input for creating a new board template.' })
export class NewBoardTemplate {
  @Field({ description: 'The name of the new board template.' })
  name: string

  @Field({ description: 'A detailed description for the new board template.' })
  description: string

  @Field({ description: 'The JSON model for the new board template.' })
  model: string

  @Field({ description: "The visibility for the new board template: 'private' or 'public'." })
  visibility: 'private' | 'public'

  @Field({ nullable: true, description: 'A base64 encoded thumbnail image for the new board template.' })
  thumbnail: string
}

@InputType({ description: 'Input for updating (patching) an existing board template.' })
export class BoardTemplatePatch {
  @Field(type => ID, { nullable: true, description: 'The unique identifier of the board template to update.' })
  id?: string

  @Field({ nullable: true, description: 'The new name for the board template.' })
  name?: string

  @Field({ nullable: true, description: 'The new description for the board template.' })
  description?: string

  @Field({ nullable: true, description: 'The new JSON model for the board template.' })
  model: string

  @Field({ nullable: true, description: "The new visibility for the board template: 'private' or 'public'." })
  visibility?: 'private' | 'public'

  @Field({ nullable: true, description: 'The new base64 encoded thumbnail image for the board template.' })
  thumbnail?: string

  @Field({
    nullable: true,
    description: 'A flag indicating whether the template is being created, updated, or deleted.'
  })
  cuFlag?: string
}

@ObjectType({ description: 'A paginated list of board templates.' })
export class BoardTemplateList {
  @Field(type => [BoardTemplate], { description: 'The list of board template items.' })
  items: BoardTemplate[]

  @Field(type => Int, { description: 'The total number of board templates.' })
  total: number
}
